export default "__VITE_ASSET__BSh8xNGG__"